/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateUploadDto } from '../../models/lexplus-create-upload-dto';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface UploadsControllerCreateV1$Params {
  kundeId: number;
  standortId?: number;
      body: LexplusCreateUploadDto
}

export function uploadsControllerCreateV1(http: HttpClient, rootUrl: string, params: UploadsControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerCreateV1.PATH, 'post');
  if (params) {
    rb.query('kundeId', params.kundeId, {});
    rb.query('standortId', params.standortId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

uploadsControllerCreateV1.PATH = '/v1/uploads';
